const normalizeItemName = (name) => {
    if (typeof name !== 'string') {
        return '';
    }
    return name.trim().replace(/\s+/g, ' ').toLocaleLowerCase();
}

const withOptionalItems = (elements = []) => {
    const items = [];

    elements.forEach((item) => {
        if (!item) {
            return;
        }

        items.push({
            item,
            type: 'base',
            identity: item.identity,
        });

        if (item.optionalItem) {
            items.push({
                item: item.optionalItem,
                type: 'optional',
                identity: item.optionalItem.identity,
                baseItemId: item.identity,
            });
        }
    });

    return items;
}

const hasIdentity = (identity) => identity !== undefined && identity !== null;

const isSameEditedItem = (entry, currentItem = {}) => {
    if (!!currentItem.baseItemId) {
        if (entry.type !== 'optional' || entry.baseItemId !== currentItem.baseItemId) {
            return false;
        }

        return hasIdentity(currentItem.identity) && entry.identity === currentItem.identity;
    }

    return entry.type === 'base' && hasIdentity(currentItem.identity) && entry.identity === currentItem.identity;
}

export const isItemNameDuplicated = (elements = [], currentItem = {}, name) => {
    const normalizedName = normalizeItemName(name);

    if (!normalizedName) {
        return false;
    }

    return withOptionalItems(elements).some((entry) => {
        return !isSameEditedItem(entry, currentItem)
            && normalizeItemName(entry.item?.name) === normalizedName;
    });
}

